/**
 * @generated SignedSource<<9c55d2c6e71a46ff42cbe538432da11f>>
 * @relayHash cd39165974b50f433e144ebf0ff7cbcb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0b17f50df3cf97905a30361320f1e1ec22045454b6eac786a0e0aab81e1ad12d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

import withInlineCreateMigration_provider from '@atlassian/jira-relay-provider/src/ibs-44-board-inline-create-migration.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0b17f50df3cf97905a30361320f1e1ec22045454b6eac786a0e0aab81e1ad12d",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": withInlineCreateMigration_provider
    }
  }
};

export default node;
